export default __webpack_public_path__ + "static/mustard-ed13fc172820d7fbe01cc08bb2d29922.png";